"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocale = exports.isSupportedLocale = exports.localeParentMap = void 0;
const constants_1 = require("./constants");
exports.localeParentMap = Object.keys(constants_1.SUPPORTED_LOCALES).reduce((locales, currentLocale) => {
    const childLocales = constants_1.SUPPORTED_LOCALES[currentLocale];
    if (childLocales) {
        childLocales.forEach((childLocale) => {
            locales[childLocale] = currentLocale;
        });
    }
    locales[currentLocale] = currentLocale;
    return locales;
}, {});
const isSupportedLocale = (locale) => {
    if (!locale)
        return false;
    return !!exports.localeParentMap[locale];
};
exports.isSupportedLocale = isSupportedLocale;
const getLocale = (locale) => {
    return exports.localeParentMap[locale];
};
exports.getLocale = getLocale;
//# sourceMappingURL=utils.js.map